import { HttpClient } from '@angular/common/http';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
// AoT requires an exported function for factories
/*
export function HttpLoaderFactory(httpClient: HttpClient) {
    return new TranslateHttpLoader(httpClient);
} */
export function HttpLoaderFactory(http) {
    return new TranslateHttpLoader(http, './assets/i18n/', // or whatever path you're using
    '.json');
}
var ɵ0 = { duration: 10000 };
var SharedModule = /** @class */ (function () {
    function SharedModule() {
    }
    return SharedModule;
}());
export { SharedModule };
export { ɵ0 };
